
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"<ALWAYS_VISIBLE>":"Filterbereich ist geöffnet","<ALWAYS_HIDDEN>":"Filterbereich ist geschlossen","<AUTO>":"AUTO-Modus"},"en":{"<ALWAYS_VISIBLE>":"Filter pane is opened","<ALWAYS_HIDDEN>":"Filter pane is closed","<AUTO>":"AUTO mode"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();